// extracted by mini-css-extract-plugin
export default {"listOfCalls":"VideoQueue_listOfCalls__gUiKU","listOfCalls__item":"VideoQueue_listOfCalls__item__+Z2ZT"};